// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="december-2021">December, 2021</h3>
      <p>We added a new API to the developer portal. This API was previously the EVSS Data Reference Service. It allows consumers to look up the following data for use with benefits claims:</p>
      <ul>
      <li>Contention types</li>
      <li>Countries</li>
      <li>Disabilities</li>
      <li>Intake sites</li>
      <li>Military pay types</li>
      <li>Service branches</li>
      <li>Special circumstances</li>
      <li>States</li>
      <li>VA medical treatment facilities</li>
      </ul>
      <p>This API will return only the data that can be used for benefits claims. For example, this API may return only a subset of states or countries that apply to benefits claims.</p>
      <p>There are some important differences between this API and the service it replaces:</p>
      <ul>
      <li>The new service requires an API key</li>
      <li>There are some stylistic differences such as changes to data types and camelCase</li>
      <li>Responses are in JSON instead of HTML</li>
      <li>For the treatment center endpoint, a 2-character state is required and any other input will now result in a 400 response rather than a 200 response or blank array</li>
      </ul>
      <p>Learn more about this API by reviewing the <Link to="/explore/benefits/docs/benefits_reference_data">Benefits Data Lookup API documentation</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
